import api from './api';

export interface AnalyticsData {
  date: string;
  total_orders: number;
  total_amount: number;
  completed_orders: number;
  completed_amount: number;
  pending_orders: number;
  completion_rate: string;
}

export interface AnalyticsResponse {
  success: boolean;
  data: AnalyticsData;
}

// Get analytics for name numerology orders
export const getNameNumerologyAnalytics = async (date: string): Promise<AnalyticsResponse> => {
  try {
    const response = await api.get(`/api/user-details/analytics/name-numerology/${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching name numerology analytics:', error);
    throw error;
  }
};

// Get analytics for compatibility orders
export const getCompatibilityAnalytics = async (date: string): Promise<AnalyticsResponse> => {
  try {
    const response = await api.get(`/api/user-details/analytics/compatibility/${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching compatibility analytics:', error);
    throw error;
  }
};

// Helper function to get today's date in YYYY-MM-DD format
export const getTodayDate = (): string => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// Helper function to get yesterday's date in YYYY-MM-DD format
export const getYesterdayDate = (): string => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.toISOString().split('T')[0];
};
